import { render } from "./CardCondecturHaventDeposit.vue?vue&type=template&id=bff699d6&ts=true"
import script from "./CardCondecturHaventDeposit.vue?vue&type=script&lang=ts"
export * from "./CardCondecturHaventDeposit.vue?vue&type=script&lang=ts"

import "./CardCondecturHaventDeposit.vue?vue&type=style&index=0&id=bff699d6&lang=scss"

import exportComponent from "/builds/harapan-jaya/hjp/hjp-cms/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__